import UnitApi from '../../api/UnitApi';
import _cloneDeep from 'lodash/cloneDeep';
import {runInAction } from 'mobx';
import {CancelSinglePromotionProcessBlock} from './promotion/CancelSinglePromotionProcessBlock';
import {SummaryProcessorBlock} from '../retail/summary/SummaryProcessorBlock'
import '../../commom/Challenger'

/**取消促销信息 */
 

import {RunSinglePromotionProcessBlock} from './promotion/RunSinglePromotionProcessBlock';
import { MergeDetailsProcessorBlock } from './MergeDetailsProcessorBlock';

export class UnitProcessorBlock {
    static async execute(dto, index, newUnit, changSource) {
        $T.debugger();
        console.log("计量单位开始改变");
        var tempDto = dto.cut();
        let retailDetail = tempDto.RetailDetails[index];

        tempDto.RetailDetails = [];
        tempDto.RetailDetails.push(retailDetail);
        let promotiondto=null;

        let promotiondtoStr = JSON.getCellValue(retailDetail, "promotiondto");
        if (promotiondtoStr) {
            promotiondto = JSON.parse(promotiondtoStr);
        }

        if (promotiondto) {
            CancelSinglePromotionProcessBlock.execute(dto,retailDetail,{'isNotRunAlgorithm':true});    
        }
        

        const returnDto = await UnitApi.unitChange(tempDto, newUnit, changSource);
        await runInAction(() => {
            $T.log("计量单位改变前的值" + JSON.stringify(returnDto));
            $T.log(JSON.stringify(dto.RetailDetails[index]));
            Object.assign(dto.RetailDetails[index], returnDto[0]);
            $T.log(JSON.stringify(dto.RetailDetails[index]));
            $T.log("计量单位改变前的值" + JSON.stringify(returnDto));
            console.log("计量单位改变--开始获取促销信息");
            RunSinglePromotionProcessBlock.execute(dto, dto.RetailDetails[index],true);
            console.log("计量单位改变--获取促销信息结束");
            // 合并重复行
            console.log("计量单位改变--开始合并行");
            MergeDetailsProcessorBlock.execute(dto);
            console.log("计量单位改变--合并行结束");
            SummaryProcessorBlock.execute(dto);
        });
        

        console.log("计量单位改变结束");
    }
}